import { render, staticRenderFns } from "./DocumentationList.vue?vue&type=template&id=2144b3fd"
import script from "./DocumentationList.vue?vue&type=script&lang=js"
export * from "./DocumentationList.vue?vue&type=script&lang=js"
import style0 from "./DocumentationList.vue?vue&type=style&index=0&id=2144b3fd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
